// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Sentiment;
(function (Sentiment) {
    Sentiment["SENTIMENT_UNKNOWN"] = "SENTIMENT_UNKNOWN";
    Sentiment["SENTIMENT_STRONGLY_NEGATIVE"] = "SENTIMENT_STRONGLY_NEGATIVE";
    Sentiment["SENTIMENT_NEGATIVE"] = "SENTIMENT_NEGATIVE";
    Sentiment["SENTIMENT_NEUTRAL"] = "SENTIMENT_NEUTRAL";
    Sentiment["SENTIMENT_POSITIVE"] = "SENTIMENT_POSITIVE";
    Sentiment["SENTIMENT_STRONGLY_POSITIVE"] = "SENTIMENT_STRONGLY_POSITIVE";
})(Sentiment || (Sentiment = {}));
export var Sentiment_index;
(function (Sentiment_index) {
    Sentiment_index[Sentiment_index["SENTIMENT_UNKNOWN"] = 0] = "SENTIMENT_UNKNOWN";
    Sentiment_index[Sentiment_index["SENTIMENT_STRONGLY_NEGATIVE"] = 1] = "SENTIMENT_STRONGLY_NEGATIVE";
    Sentiment_index[Sentiment_index["SENTIMENT_NEGATIVE"] = 2] = "SENTIMENT_NEGATIVE";
    Sentiment_index[Sentiment_index["SENTIMENT_NEUTRAL"] = 3] = "SENTIMENT_NEUTRAL";
    Sentiment_index[Sentiment_index["SENTIMENT_POSITIVE"] = 4] = "SENTIMENT_POSITIVE";
    Sentiment_index[Sentiment_index["SENTIMENT_STRONGLY_POSITIVE"] = 5] = "SENTIMENT_STRONGLY_POSITIVE";
})(Sentiment_index || (Sentiment_index = {}));
export var CallStatus;
(function (CallStatus) {
    CallStatus["CALL_STATUS_UNKNOWN"] = "CALL_STATUS_UNKNOWN";
    CallStatus["CALL_STATUS_PENDING"] = "CALL_STATUS_PENDING";
    CallStatus["CALL_STATUS_TRANSCRIBING"] = "CALL_STATUS_TRANSCRIBING";
    CallStatus["CALL_STATUS_INFERENCING"] = "CALL_STATUS_INFERENCING";
    CallStatus["CALL_STATUS_COMPLETE"] = "CALL_STATUS_COMPLETE";
    CallStatus["CALL_STATUS_FAILED"] = "CALL_STATUS_FAILED";
    CallStatus["CALL_STATUS_SKIPPED"] = "CALL_STATUS_SKIPPED";
    CallStatus["CALL_STATUS_ERROR"] = "CALL_STATUS_ERROR";
    CallStatus["CALL_STATUS_VOICEMAIL"] = "CALL_STATUS_VOICEMAIL";
})(CallStatus || (CallStatus = {}));
export var CallStatus_index;
(function (CallStatus_index) {
    CallStatus_index[CallStatus_index["CALL_STATUS_UNKNOWN"] = 0] = "CALL_STATUS_UNKNOWN";
    CallStatus_index[CallStatus_index["CALL_STATUS_PENDING"] = 1] = "CALL_STATUS_PENDING";
    CallStatus_index[CallStatus_index["CALL_STATUS_TRANSCRIBING"] = 2] = "CALL_STATUS_TRANSCRIBING";
    CallStatus_index[CallStatus_index["CALL_STATUS_INFERENCING"] = 3] = "CALL_STATUS_INFERENCING";
    CallStatus_index[CallStatus_index["CALL_STATUS_COMPLETE"] = 4] = "CALL_STATUS_COMPLETE";
    CallStatus_index[CallStatus_index["CALL_STATUS_FAILED"] = 5] = "CALL_STATUS_FAILED";
    CallStatus_index[CallStatus_index["CALL_STATUS_SKIPPED"] = 6] = "CALL_STATUS_SKIPPED";
    CallStatus_index[CallStatus_index["CALL_STATUS_ERROR"] = 7] = "CALL_STATUS_ERROR";
    CallStatus_index[CallStatus_index["CALL_STATUS_VOICEMAIL"] = 8] = "CALL_STATUS_VOICEMAIL";
})(CallStatus_index || (CallStatus_index = {}));
export var Category;
(function (Category) {
    Category["CATEGORY_UNKNOWN"] = "CATEGORY_UNKNOWN";
    Category["CATEGORY_SCHEDULING"] = "CATEGORY_SCHEDULING";
    Category["CATEGORY_EMERGENCY"] = "CATEGORY_EMERGENCY";
    Category["CATEGORY_COMPLAINT"] = "CATEGORY_COMPLAINT";
    Category["CATEGORY_BILLING"] = "CATEGORY_BILLING";
    Category["CATEGORY_VENDOR"] = "CATEGORY_VENDOR";
    Category["CATEGORY_OTHER"] = "CATEGORY_OTHER";
    Category["CATEGORY_MEDICATION"] = "CATEGORY_MEDICATION";
})(Category || (Category = {}));
export var Category_index;
(function (Category_index) {
    Category_index[Category_index["CATEGORY_UNKNOWN"] = 0] = "CATEGORY_UNKNOWN";
    Category_index[Category_index["CATEGORY_SCHEDULING"] = 1] = "CATEGORY_SCHEDULING";
    Category_index[Category_index["CATEGORY_EMERGENCY"] = 2] = "CATEGORY_EMERGENCY";
    Category_index[Category_index["CATEGORY_COMPLAINT"] = 6] = "CATEGORY_COMPLAINT";
    Category_index[Category_index["CATEGORY_BILLING"] = 7] = "CATEGORY_BILLING";
    Category_index[Category_index["CATEGORY_VENDOR"] = 8] = "CATEGORY_VENDOR";
    Category_index[Category_index["CATEGORY_OTHER"] = 10] = "CATEGORY_OTHER";
    Category_index[Category_index["CATEGORY_MEDICATION"] = 11] = "CATEGORY_MEDICATION";
})(Category_index || (Category_index = {}));
export var AppointmentType;
(function (AppointmentType) {
    AppointmentType["APPOINTMENT_TYPE_UNKNOWN"] = "APPOINTMENT_TYPE_UNKNOWN";
    AppointmentType["APPOINTMENT_TYPE_IMAGING"] = "APPOINTMENT_TYPE_IMAGING";
    AppointmentType["APPOINTMENT_TYPE_COSMETIC"] = "APPOINTMENT_TYPE_COSMETIC";
    AppointmentType["APPOINTMENT_TYPE_ORTHODONTICS"] = "APPOINTMENT_TYPE_ORTHODONTICS";
    AppointmentType["APPOINTMENT_TYPE_SURGERY"] = "APPOINTMENT_TYPE_SURGERY";
    AppointmentType["APPOINTMENT_TYPE_PREVENTIVE"] = "APPOINTMENT_TYPE_PREVENTIVE";
    AppointmentType["APPOINTMENT_TYPE_HYGIENE"] = "APPOINTMENT_TYPE_HYGIENE";
    AppointmentType["APPOINTMENT_TYPE_RESTORATIVE"] = "APPOINTMENT_TYPE_RESTORATIVE";
    AppointmentType["APPOINTMENT_TYPE_EMERGENCY"] = "APPOINTMENT_TYPE_EMERGENCY";
})(AppointmentType || (AppointmentType = {}));
export var AppointmentType_index;
(function (AppointmentType_index) {
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_UNKNOWN"] = 0] = "APPOINTMENT_TYPE_UNKNOWN";
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_IMAGING"] = 1] = "APPOINTMENT_TYPE_IMAGING";
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_COSMETIC"] = 2] = "APPOINTMENT_TYPE_COSMETIC";
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_ORTHODONTICS"] = 3] = "APPOINTMENT_TYPE_ORTHODONTICS";
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_SURGERY"] = 4] = "APPOINTMENT_TYPE_SURGERY";
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_PREVENTIVE"] = 5] = "APPOINTMENT_TYPE_PREVENTIVE";
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_HYGIENE"] = 6] = "APPOINTMENT_TYPE_HYGIENE";
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_RESTORATIVE"] = 7] = "APPOINTMENT_TYPE_RESTORATIVE";
    AppointmentType_index[AppointmentType_index["APPOINTMENT_TYPE_EMERGENCY"] = 8] = "APPOINTMENT_TYPE_EMERGENCY";
})(AppointmentType_index || (AppointmentType_index = {}));
export var FilterType;
(function (FilterType) {
    FilterType["FILTER_BY_UNKNOWN"] = "FILTER_BY_UNKNOWN";
    FilterType["FILTER_BY_DATE_RANGE"] = "FILTER_BY_DATE_RANGE";
    FilterType["FILTER_BY_LOCATION"] = "FILTER_BY_LOCATION";
    FilterType["FILTER_BY_SENTIMENT"] = "FILTER_BY_SENTIMENT";
    FilterType["FILTER_BY_CATEGORY"] = "FILTER_BY_CATEGORY";
    FilterType["FILTER_BY_APPOINTMENT_TYPE"] = "FILTER_BY_APPOINTMENT_TYPE";
    FilterType["FILTER_BY_CALL_STATUS"] = "FILTER_BY_CALL_STATUS";
    FilterType["FILTER_BY_SCHEDULING_OUTCOME"] = "FILTER_BY_SCHEDULING_OUTCOME";
    FilterType["FILTER_BY_OPPORTUNITY"] = "FILTER_BY_OPPORTUNITY";
    FilterType["FILTER_BY_OFFICE_USER"] = "FILTER_BY_OFFICE_USER";
    FilterType["FILTER_BY_OFFICE_NUMBER"] = "FILTER_BY_OFFICE_NUMBER";
    FilterType["FILTER_BY_CALL_DIRECTION"] = "FILTER_BY_CALL_DIRECTION";
    FilterType["FILTER_BY_CONTACT_TYPE"] = "FILTER_BY_CONTACT_TYPE";
    FilterType["FILTER_BY_CALL_ID"] = "FILTER_BY_CALL_ID";
    FilterType["FILTER_BY_SERVICE_QUALITY"] = "FILTER_BY_SERVICE_QUALITY";
})(FilterType || (FilterType = {}));
export var FilterType_index;
(function (FilterType_index) {
    FilterType_index[FilterType_index["FILTER_BY_UNKNOWN"] = 0] = "FILTER_BY_UNKNOWN";
    FilterType_index[FilterType_index["FILTER_BY_DATE_RANGE"] = 1] = "FILTER_BY_DATE_RANGE";
    FilterType_index[FilterType_index["FILTER_BY_LOCATION"] = 2] = "FILTER_BY_LOCATION";
    FilterType_index[FilterType_index["FILTER_BY_SENTIMENT"] = 3] = "FILTER_BY_SENTIMENT";
    FilterType_index[FilterType_index["FILTER_BY_CATEGORY"] = 4] = "FILTER_BY_CATEGORY";
    FilterType_index[FilterType_index["FILTER_BY_APPOINTMENT_TYPE"] = 5] = "FILTER_BY_APPOINTMENT_TYPE";
    FilterType_index[FilterType_index["FILTER_BY_CALL_STATUS"] = 6] = "FILTER_BY_CALL_STATUS";
    FilterType_index[FilterType_index["FILTER_BY_SCHEDULING_OUTCOME"] = 7] = "FILTER_BY_SCHEDULING_OUTCOME";
    FilterType_index[FilterType_index["FILTER_BY_OPPORTUNITY"] = 8] = "FILTER_BY_OPPORTUNITY";
    FilterType_index[FilterType_index["FILTER_BY_OFFICE_USER"] = 9] = "FILTER_BY_OFFICE_USER";
    FilterType_index[FilterType_index["FILTER_BY_OFFICE_NUMBER"] = 10] = "FILTER_BY_OFFICE_NUMBER";
    FilterType_index[FilterType_index["FILTER_BY_CALL_DIRECTION"] = 11] = "FILTER_BY_CALL_DIRECTION";
    FilterType_index[FilterType_index["FILTER_BY_CONTACT_TYPE"] = 12] = "FILTER_BY_CONTACT_TYPE";
    FilterType_index[FilterType_index["FILTER_BY_CALL_ID"] = 13] = "FILTER_BY_CALL_ID";
    FilterType_index[FilterType_index["FILTER_BY_SERVICE_QUALITY"] = 14] = "FILTER_BY_SERVICE_QUALITY";
})(FilterType_index || (FilterType_index = {}));
export var SortType;
(function (SortType) {
    SortType["SORT_UNKNOWN"] = "SORT_UNKNOWN";
    SortType["SORT_ASC"] = "SORT_ASC";
    SortType["SORT_DESC"] = "SORT_DESC";
})(SortType || (SortType = {}));
export var SortType_index;
(function (SortType_index) {
    SortType_index[SortType_index["SORT_UNKNOWN"] = 0] = "SORT_UNKNOWN";
    SortType_index[SortType_index["SORT_ASC"] = 1] = "SORT_ASC";
    SortType_index[SortType_index["SORT_DESC"] = 2] = "SORT_DESC";
})(SortType_index || (SortType_index = {}));
export var CallDirection;
(function (CallDirection) {
    CallDirection["DIRECTION_UNKNOWN"] = "DIRECTION_UNKNOWN";
    CallDirection["DIRECTION_INBOUND"] = "DIRECTION_INBOUND";
    CallDirection["DIRECTION_OUTBOUND"] = "DIRECTION_OUTBOUND";
})(CallDirection || (CallDirection = {}));
export var CallDirection_index;
(function (CallDirection_index) {
    CallDirection_index[CallDirection_index["DIRECTION_UNKNOWN"] = 0] = "DIRECTION_UNKNOWN";
    CallDirection_index[CallDirection_index["DIRECTION_INBOUND"] = 1] = "DIRECTION_INBOUND";
    CallDirection_index[CallDirection_index["DIRECTION_OUTBOUND"] = 2] = "DIRECTION_OUTBOUND";
})(CallDirection_index || (CallDirection_index = {}));
export var Rating;
(function (Rating) {
    Rating["RATING_UNKNOWN"] = "RATING_UNKNOWN";
    Rating["RATING_POSITIVE"] = "RATING_POSITIVE";
    Rating["RATING_NEGATIVE"] = "RATING_NEGATIVE";
    Rating["RATING_NEUTRAL"] = "RATING_NEUTRAL";
    Rating["RATING_STRONG_POSITIVE"] = "RATING_STRONG_POSITIVE";
    Rating["RATING_STRONG_NEGATIVE"] = "RATING_STRONG_NEGATIVE";
})(Rating || (Rating = {}));
export var Rating_index;
(function (Rating_index) {
    Rating_index[Rating_index["RATING_UNKNOWN"] = 0] = "RATING_UNKNOWN";
    Rating_index[Rating_index["RATING_POSITIVE"] = 1] = "RATING_POSITIVE";
    Rating_index[Rating_index["RATING_NEGATIVE"] = 2] = "RATING_NEGATIVE";
    Rating_index[Rating_index["RATING_NEUTRAL"] = 3] = "RATING_NEUTRAL";
    Rating_index[Rating_index["RATING_STRONG_POSITIVE"] = 4] = "RATING_STRONG_POSITIVE";
    Rating_index[Rating_index["RATING_STRONG_NEGATIVE"] = 5] = "RATING_STRONG_NEGATIVE";
})(Rating_index || (Rating_index = {}));
export var ContactType;
(function (ContactType) {
    ContactType["CONTACT_UNKNOWN"] = "CONTACT_UNKNOWN";
    ContactType["CONTACT_NEW_PATIENT"] = "CONTACT_NEW_PATIENT";
    ContactType["CONTACT_EXISTING_PATIENT"] = "CONTACT_EXISTING_PATIENT";
    ContactType["CONTACT_NOT_A_PATIENT"] = "CONTACT_NOT_A_PATIENT";
})(ContactType || (ContactType = {}));
export var ContactType_index;
(function (ContactType_index) {
    ContactType_index[ContactType_index["CONTACT_UNKNOWN"] = 0] = "CONTACT_UNKNOWN";
    ContactType_index[ContactType_index["CONTACT_NEW_PATIENT"] = 1] = "CONTACT_NEW_PATIENT";
    ContactType_index[ContactType_index["CONTACT_EXISTING_PATIENT"] = 2] = "CONTACT_EXISTING_PATIENT";
    ContactType_index[ContactType_index["CONTACT_NOT_A_PATIENT"] = 3] = "CONTACT_NOT_A_PATIENT";
})(ContactType_index || (ContactType_index = {}));
export var SearchType;
(function (SearchType) {
    SearchType["SEARCH_UNKNOWN"] = "SEARCH_UNKNOWN";
    SearchType["SEARCH_BY_NAME"] = "SEARCH_BY_NAME";
    SearchType["SEARCH_BY_NUMBER"] = "SEARCH_BY_NUMBER";
})(SearchType || (SearchType = {}));
export var SearchType_index;
(function (SearchType_index) {
    SearchType_index[SearchType_index["SEARCH_UNKNOWN"] = 0] = "SEARCH_UNKNOWN";
    SearchType_index[SearchType_index["SEARCH_BY_NAME"] = 1] = "SEARCH_BY_NAME";
    SearchType_index[SearchType_index["SEARCH_BY_NUMBER"] = 2] = "SEARCH_BY_NUMBER";
})(SearchType_index || (SearchType_index = {}));
export var TaskSubType;
(function (TaskSubType) {
    TaskSubType["TASK_SUBTYPE_UNKNOWN"] = "TASK_SUBTYPE_UNKNOWN";
    TaskSubType["TASK_SUBTYPE_REMINDER"] = "TASK_SUBTYPE_REMINDER";
    TaskSubType["TASK_SUBTYPE_CANCELLED"] = "TASK_SUBTYPE_CANCELLED";
    TaskSubType["TASK_SUBTYPE_CONFIRMED"] = "TASK_SUBTYPE_CONFIRMED";
    TaskSubType["TASK_SUBTYPE_NEW_PATIENT_PAPERWORK"] = "TASK_SUBTYPE_NEW_PATIENT_PAPERWORK";
    TaskSubType["TASK_SUBTYPE_OTHER"] = "TASK_SUBTYPE_OTHER";
})(TaskSubType || (TaskSubType = {}));
export var TaskSubType_index;
(function (TaskSubType_index) {
    TaskSubType_index[TaskSubType_index["TASK_SUBTYPE_UNKNOWN"] = 0] = "TASK_SUBTYPE_UNKNOWN";
    TaskSubType_index[TaskSubType_index["TASK_SUBTYPE_REMINDER"] = 1] = "TASK_SUBTYPE_REMINDER";
    TaskSubType_index[TaskSubType_index["TASK_SUBTYPE_CANCELLED"] = 2] = "TASK_SUBTYPE_CANCELLED";
    TaskSubType_index[TaskSubType_index["TASK_SUBTYPE_CONFIRMED"] = 3] = "TASK_SUBTYPE_CONFIRMED";
    TaskSubType_index[TaskSubType_index["TASK_SUBTYPE_NEW_PATIENT_PAPERWORK"] = 4] = "TASK_SUBTYPE_NEW_PATIENT_PAPERWORK";
    TaskSubType_index[TaskSubType_index["TASK_SUBTYPE_OTHER"] = 5] = "TASK_SUBTYPE_OTHER";
})(TaskSubType_index || (TaskSubType_index = {}));
export var ReportType;
(function (ReportType) {
    ReportType["REPORT_UNKNOWN"] = "REPORT_UNKNOWN";
    ReportType["REPORT_WEEKLY"] = "REPORT_WEEKLY";
    ReportType["REPORT_DAILY"] = "REPORT_DAILY";
})(ReportType || (ReportType = {}));
export var ReportType_index;
(function (ReportType_index) {
    ReportType_index[ReportType_index["REPORT_UNKNOWN"] = 0] = "REPORT_UNKNOWN";
    ReportType_index[ReportType_index["REPORT_WEEKLY"] = 1] = "REPORT_WEEKLY";
    ReportType_index[ReportType_index["REPORT_DAILY"] = 2] = "REPORT_DAILY";
})(ReportType_index || (ReportType_index = {}));
export var FollowupsFilterType;
(function (FollowupsFilterType) {
    FollowupsFilterType["FOLLOWUPS_FILTER_BY_UNKNOWN"] = "FOLLOWUPS_FILTER_BY_UNKNOWN";
    FollowupsFilterType["FOLLOWUPS_FILTER_BY_DATE_RANGE"] = "FOLLOWUPS_FILTER_BY_DATE_RANGE";
    FollowupsFilterType["FOLLOWUPS_FILTER_BY_LOCATION"] = "FOLLOWUPS_FILTER_BY_LOCATION";
    FollowupsFilterType["FOLLOWUPS_FILTER_BY_OFFICE_USER"] = "FOLLOWUPS_FILTER_BY_OFFICE_USER";
    FollowupsFilterType["FOLLOWUPS_FILTER_BY_CONTACT_TYPE"] = "FOLLOWUPS_FILTER_BY_CONTACT_TYPE";
    FollowupsFilterType["FOLLOWUPS_FILTER_BY_TASK_TYPE"] = "FOLLOWUPS_FILTER_BY_TASK_TYPE";
    FollowupsFilterType["FOLLOWUPS_FILTER_BY_TASK_STATUS"] = "FOLLOWUPS_FILTER_BY_TASK_STATUS";
})(FollowupsFilterType || (FollowupsFilterType = {}));
export var FollowupsFilterType_index;
(function (FollowupsFilterType_index) {
    FollowupsFilterType_index[FollowupsFilterType_index["FOLLOWUPS_FILTER_BY_UNKNOWN"] = 0] = "FOLLOWUPS_FILTER_BY_UNKNOWN";
    FollowupsFilterType_index[FollowupsFilterType_index["FOLLOWUPS_FILTER_BY_DATE_RANGE"] = 1] = "FOLLOWUPS_FILTER_BY_DATE_RANGE";
    FollowupsFilterType_index[FollowupsFilterType_index["FOLLOWUPS_FILTER_BY_LOCATION"] = 2] = "FOLLOWUPS_FILTER_BY_LOCATION";
    FollowupsFilterType_index[FollowupsFilterType_index["FOLLOWUPS_FILTER_BY_OFFICE_USER"] = 3] = "FOLLOWUPS_FILTER_BY_OFFICE_USER";
    FollowupsFilterType_index[FollowupsFilterType_index["FOLLOWUPS_FILTER_BY_CONTACT_TYPE"] = 4] = "FOLLOWUPS_FILTER_BY_CONTACT_TYPE";
    FollowupsFilterType_index[FollowupsFilterType_index["FOLLOWUPS_FILTER_BY_TASK_TYPE"] = 5] = "FOLLOWUPS_FILTER_BY_TASK_TYPE";
    FollowupsFilterType_index[FollowupsFilterType_index["FOLLOWUPS_FILTER_BY_TASK_STATUS"] = 6] = "FOLLOWUPS_FILTER_BY_TASK_STATUS";
})(FollowupsFilterType_index || (FollowupsFilterType_index = {}));
export var FollowupsSortBy;
(function (FollowupsSortBy) {
    FollowupsSortBy["FOLLOWUPS_SORT_UNKNOWN"] = "FOLLOWUPS_SORT_UNKNOWN";
    FollowupsSortBy["FOLLOWUPS_SORT_LAST_CALL"] = "FOLLOWUPS_SORT_LAST_CALL";
    FollowupsSortBy["FOLLOWUPS_SORT_CALLS_COUNT"] = "FOLLOWUPS_SORT_CALLS_COUNT";
})(FollowupsSortBy || (FollowupsSortBy = {}));
export var FollowupsSortBy_index;
(function (FollowupsSortBy_index) {
    FollowupsSortBy_index[FollowupsSortBy_index["FOLLOWUPS_SORT_UNKNOWN"] = 0] = "FOLLOWUPS_SORT_UNKNOWN";
    FollowupsSortBy_index[FollowupsSortBy_index["FOLLOWUPS_SORT_LAST_CALL"] = 1] = "FOLLOWUPS_SORT_LAST_CALL";
    FollowupsSortBy_index[FollowupsSortBy_index["FOLLOWUPS_SORT_CALLS_COUNT"] = 2] = "FOLLOWUPS_SORT_CALLS_COUNT";
})(FollowupsSortBy_index || (FollowupsSortBy_index = {}));
export var ServiceQualityFlag;
(function (ServiceQualityFlag) {
    ServiceQualityFlag["FLAG_UNKNOWN"] = "FLAG_UNKNOWN";
    ServiceQualityFlag["FLAG_UNRESOLVED_ISSUE"] = "FLAG_UNRESOLVED_ISSUE";
    ServiceQualityFlag["FLAG_EXCELLENT_RESOLUTION"] = "FLAG_EXCELLENT_RESOLUTION";
})(ServiceQualityFlag || (ServiceQualityFlag = {}));
export var ServiceQualityFlag_index;
(function (ServiceQualityFlag_index) {
    ServiceQualityFlag_index[ServiceQualityFlag_index["FLAG_UNKNOWN"] = 0] = "FLAG_UNKNOWN";
    ServiceQualityFlag_index[ServiceQualityFlag_index["FLAG_UNRESOLVED_ISSUE"] = 1] = "FLAG_UNRESOLVED_ISSUE";
    ServiceQualityFlag_index[ServiceQualityFlag_index["FLAG_EXCELLENT_RESOLUTION"] = 2] = "FLAG_EXCELLENT_RESOLUTION";
})(ServiceQualityFlag_index || (ServiceQualityFlag_index = {}));
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["FEEDBACK_UNKNOWN"] = "FEEDBACK_UNKNOWN";
    FeedbackType["FEEDBACK_AI"] = "FEEDBACK_AI";
    FeedbackType["FEEDBACK_GENERAL"] = "FEEDBACK_GENERAL";
})(FeedbackType || (FeedbackType = {}));
export var FeedbackType_index;
(function (FeedbackType_index) {
    FeedbackType_index[FeedbackType_index["FEEDBACK_UNKNOWN"] = 0] = "FEEDBACK_UNKNOWN";
    FeedbackType_index[FeedbackType_index["FEEDBACK_AI"] = 1] = "FEEDBACK_AI";
    FeedbackType_index[FeedbackType_index["FEEDBACK_GENERAL"] = 2] = "FEEDBACK_GENERAL";
})(FeedbackType_index || (FeedbackType_index = {}));
export var AnalysisType;
(function (AnalysisType) {
    AnalysisType["ANALYSIS_TYPE_UNKNOWN"] = "ANALYSIS_TYPE_UNKNOWN";
    AnalysisType["ANALYSIS_TYPE_CONTACT_TYPE"] = "ANALYSIS_TYPE_CONTACT_TYPE";
    AnalysisType["ANALYSIS_TYPE_SENTIMENT"] = "ANALYSIS_TYPE_SENTIMENT";
    AnalysisType["ANALYSIS_TYPE_SCHEDULING_OPPORTUNITY"] = "ANALYSIS_TYPE_SCHEDULING_OPPORTUNITY";
    AnalysisType["ANALYSIS_TYPE_SCHEDULING_OUTCOME"] = "ANALYSIS_TYPE_SCHEDULING_OUTCOME";
    AnalysisType["ANALYSIS_TYPE_CATEGORY"] = "ANALYSIS_TYPE_CATEGORY";
    AnalysisType["ANALYSIS_TYPE_APPOINTMENT_TYPE"] = "ANALYSIS_TYPE_APPOINTMENT_TYPE";
    AnalysisType["ANALYSIS_TYPE_SERVICE_QUALITY"] = "ANALYSIS_TYPE_SERVICE_QUALITY";
})(AnalysisType || (AnalysisType = {}));
export var AnalysisType_index;
(function (AnalysisType_index) {
    AnalysisType_index[AnalysisType_index["ANALYSIS_TYPE_UNKNOWN"] = 0] = "ANALYSIS_TYPE_UNKNOWN";
    AnalysisType_index[AnalysisType_index["ANALYSIS_TYPE_CONTACT_TYPE"] = 1] = "ANALYSIS_TYPE_CONTACT_TYPE";
    AnalysisType_index[AnalysisType_index["ANALYSIS_TYPE_SENTIMENT"] = 2] = "ANALYSIS_TYPE_SENTIMENT";
    AnalysisType_index[AnalysisType_index["ANALYSIS_TYPE_SCHEDULING_OPPORTUNITY"] = 3] = "ANALYSIS_TYPE_SCHEDULING_OPPORTUNITY";
    AnalysisType_index[AnalysisType_index["ANALYSIS_TYPE_SCHEDULING_OUTCOME"] = 4] = "ANALYSIS_TYPE_SCHEDULING_OUTCOME";
    AnalysisType_index[AnalysisType_index["ANALYSIS_TYPE_CATEGORY"] = 5] = "ANALYSIS_TYPE_CATEGORY";
    AnalysisType_index[AnalysisType_index["ANALYSIS_TYPE_APPOINTMENT_TYPE"] = 6] = "ANALYSIS_TYPE_APPOINTMENT_TYPE";
    AnalysisType_index[AnalysisType_index["ANALYSIS_TYPE_SERVICE_QUALITY"] = 7] = "ANALYSIS_TYPE_SERVICE_QUALITY";
})(AnalysisType_index || (AnalysisType_index = {}));
